
import {
  defineComponent, ref, onMounted, watch,
} from 'vue';
import { useRouter } from 'vue-router';
import { Form, defineRule } from 'vee-validate';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '@/store/mainStore';
import { useRegistrationStore } from '@/modules/registration/store/registrationStore';
import AppInputCode from '@/components/UI/AppInputCode.vue';
import AppButton from '@/components/UI/AppButton.vue';
import ValidationService from '@/services/ValidationService';
// eslint-disable-next-line import/no-cycle
import MonitoringService from '@/services/MonitoringService';
// eslint-disable-next-line import/no-cycle
import RegistrationService from '@/modules/registration/services/RegistrationService';
import {
  ACCOUNT_STATUS, REGISTRATION_STATE, USER_STATUS, VERIFICATION_STATUS,
} from '@/types/enums';

defineRule('required', (value:string) => ValidationService.isNotEmpty(value) || 'This field is required');
defineRule('onlyNumbers', (value:string) => ValidationService.onlyNumbers(value) || 'Use only numbers');

export default defineComponent({
  components: {
    Form,
    AppInputCode,
    AppButton,
  },
  setup() {
    const router = useRouter();
    const registrationStore = useRegistrationStore();
    const mainStore = useMainStore();

    const codeLength = ref(6);
    const schema = {
      code: 'required|onlyNumbers',
    };

    const codeValue = ref('');
    const codeError = ref('');

    function nextStep() {
      const payload = {
        phoneNumber: registrationStore.phoneNumberCode + registrationStore.phoneNumber,
        code: codeValue.value,
      };

      RegistrationService.checkVerifyCode(payload).then((response) => {
        if (response.success) {
          if (response.results.data === VERIFICATION_STATUS.SUCCESS) {
            mainStore.user.accountStatuses.push(ACCOUNT_STATUS.PHONE_NUMBER_CONFIRMED);
            mainStore.user.registrationState = REGISTRATION_STATE.CONFIRM_EMAIL;
            mainStore.user.status = USER_STATUS.CONFIRM_EMAIL;
            router.push({ name: 'Welcome' });
          }
          if (response.results.data === VERIFICATION_STATUS.FAILED) {
            codeError.value = 'Invalid code';
          }
        } else {
          codeError.value = 'Something gone wrong';
        }
      });
    }

    watch(() => codeValue.value, (nv, ov) => {
      if ((nv !== ov) && (ov !== null)) {
        codeError.value = '';
      }
    });

    onMounted(() => {
      if (!registrationStore.phoneNumber) {
        router.push('step-7');
      }
      MonitoringService.sendPageMountedSpeed();
    });

    return {
      schema,
      codeValue,
      nextStep,
      codeLength,
      codeError,
    };
  },
});
